const digitRegEx = /\d+/g;
const parseDigits = (input: string) => (input.match(digitRegEx) || []).join('');

export const formatPhone = (input: string) => {
    if (digitRegEx.test(input) && input !== '') {
        const digits = parseDigits(input).substr(0, 8);
        const formatNumber = digits.match(/.{1,2}/g) as Array<string>;
        return formatNumber.join(' ') as string;
    }
    return '';
};
